import { render, staticRenderFns } from "./ShippingPostcodeAdditionalFeeEdit.vue?vue&type=template&id=16228454&"
import script from "./ShippingPostcodeAdditionalFeeEdit.vue?vue&type=script&lang=js&"
export * from "./ShippingPostcodeAdditionalFeeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports